import { WorkingTimeImportStatus } from "@/orval/gen"
import {
  IconExclamationMark,
  IconX,
  IconTrash,
  IconBan,
  IconCheck,
  IconHourglass,
  IconPencil,
  IconPlus,
  IconProps,
} from "@tabler/icons-react"
import { match } from "ts-pattern"

const iconProps: IconProps = {
  size: 12,
}

export function WorkingTimeImportStatusIcon({
  status,
}: {
  status: WorkingTimeImportStatus
}) {
  return match(status)
    .with("Failed", () => <IconExclamationMark {...iconProps} />)
    .with("Rejected", () => <IconX {...iconProps} />)
    .with("Deleted", () => <IconTrash {...iconProps} />)
    .with("Cancelled", () => <IconBan {...iconProps} />)
    .with(
      "Approved",
      "Finished",
      "Revised",
      "FinishedWithTimeRuleValidationError",
      "FinishedAfterRevised",
      () => <IconCheck {...iconProps} />
    )
    .with("Requested", () => <IconHourglass {...iconProps} />)
    .with("Edited", () => <IconPencil {...iconProps} />)
    .with("New", () => <IconPlus {...iconProps} />)
    .exhaustive()
}
